'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled, { useTheme } from 'styled-components';
import { isHalloween } from '../operators/isHalloween';
import { SpiderWebLeft, SpiderWebRight } from './SpiderWebs';
import { Spiders } from './Spider';
var ThemedPage = styled.div.withConfig({
  displayName: "ThemedLoadingPage__ThemedPage",
  componentId: "mlp38d-0"
})(["background:", ";background-color:", ";background-size:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.loadingPage.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.loadingPage.backgroundColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.loadingPage.backgroundSize;
});
export var ThemedLoadingPage = function ThemedLoadingPage(_ref4) {
  var children = _ref4.children;
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(ThemedPage, {
    children: [isHalloween(theme) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SpiderWebLeft, {}), /*#__PURE__*/_jsx(SpiderWebRight, {}), /*#__PURE__*/_jsx(Spiders, {})]
    }), children]
  });
};